module.exports = __webpack_public_path__ + "img/logo.92696010.svg";